(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // 五列菜单布局功能
  function arrangeFiveColumnMenus() {
    const fiveColumnMenus = document.querySelectorAll('.five-column-menu-list:has(.five-column-menu-item)');
    
    fiveColumnMenus.forEach(menu => {
      const items = Array.from(menu.querySelectorAll('.five-column-menu-item'));
      const totalItems = items.length;
      
      if (totalItems === 0) return;
      
      // 计算每列应该有多少行
      const itemsPerColumn = Math.ceil(totalItems / 5);
      
      // 清除所有元素的grid属性
      items.forEach(item => {
        item.style.gridColumn = '';
        item.style.gridRow = '';
      });
      
      // 按列分配元素
      items.forEach((item, index) => {
        const column = Math.floor(index / itemsPerColumn) + 1;
        const row = (index % itemsPerColumn) + 1;
        
        // 确保不超过5列
        if (column <= 5) {
          item.style.gridColumn = column;
          item.style.gridRow = row;
        }
      });
      
      // 设置网格行数
      menu.style.gridTemplateRows = `repeat(${itemsPerColumn}, auto)`;
    });
  }

  // 页面加载时执行
  document.addEventListener('DOMContentLoaded', arrangeFiveColumnMenus);
  
  // 监听菜单打开事件，确保动态内容也能正确布局
  document.addEventListener('click', function(e) {
    if (e.target.closest('summary')) {
      setTimeout(arrangeFiveColumnMenus, 10);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // 五列菜单布局功能
  function arrangeFiveColumnMenus() {
    const fiveColumnMenus = document.querySelectorAll('.five-column-menu-list:has(.five-column-menu-item)');
    
    fiveColumnMenus.forEach(menu => {
      const items = Array.from(menu.querySelectorAll('.five-column-menu-item'));
      const totalItems = items.length;
      
      if (totalItems === 0) return;
      
      // 计算每列应该有多少行
      const itemsPerColumn = Math.ceil(totalItems / 5);
      
      // 清除所有元素的grid属性
      items.forEach(item => {
        item.style.gridColumn = '';
        item.style.gridRow = '';
      });
      
      // 按列分配元素
      items.forEach((item, index) => {
        const column = Math.floor(index / itemsPerColumn) + 1;
        const row = (index % itemsPerColumn) + 1;
        
        // 确保不超过5列
        if (column <= 5) {
          item.style.gridColumn = column;
          item.style.gridRow = row;
        }
      });
      
      // 设置网格行数
      menu.style.gridTemplateRows = `repeat(${itemsPerColumn}, auto)`;
    });
  }

  // 页面加载时执行
  document.addEventListener('DOMContentLoaded', arrangeFiveColumnMenus);
  
  // 监听菜单打开事件，确保动态内容也能正确布局
  document.addEventListener('click', function(e) {
    if (e.target.closest('summary')) {
      setTimeout(arrangeFiveColumnMenus, 10);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slide-column"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const wrappers = document.querySelectorAll(".multicolumn-slide-wrapper");

  wrappers.forEach(function(wrapper) {
    const container = wrapper.querySelector(".multicolumn-list");
    const prevBtn = wrapper.querySelector(".slider-button--prev");
    const nextBtn = wrapper.querySelector(".slider-button--next");

    function updateButtons() {
      prevBtn.disabled = container.scrollLeft <= 0;
      nextBtn.disabled = container.scrollLeft + container.offsetWidth >= container.scrollWidth - 1;
    }

    prevBtn.addEventListener("click", function() {
      container.scrollBy({ left: -container.querySelector(".multicolumn-list__item").offsetWidth, behavior: "smooth" });
      setTimeout(updateButtons, 200);
    });

    nextBtn.addEventListener("click", function() {
      container.scrollBy({ left: container.querySelector(".multicolumn-list__item").offsetWidth, behavior: "smooth" });
      setTimeout(updateButtons, 200);
    });

    container.addEventListener("scroll", updateButtons);
    updateButtons();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-list"] && !Shopify.designMode) return;
  try {
    
  document.querySelector(".product-tab").onclick=(event)=>{
    if(event.target==document.querySelector(".product-tab-active") || event.target==document.querySelector(".product-tab"))return
    document.querySelector(".product-tab-active").classList.remove("product-tab-active")
    event.target.classList.add("product-tab-active")
    const tab_index = event.target.getAttribute("tab-index")
    document.querySelector(".product-tab-content .show").classList.add("hidden")
    document.querySelector(".product-tab-content .show").classList.remove("show")
    document.querySelectorAll(".product-tab-item")[tab_index].classList.remove("hidden")
    document.querySelectorAll(".product-tab-item")[tab_index].classList.add("show")
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".tab-section-item-title").forEach(el=>{
      el.addEventListener("click",(event)=>{
        if(el.classList.contains("tab-section-item-title-active"))return;
        const sectionId = el.getAttribute("data-section");
        if(sectionId){
          document.querySelectorAll(".tab-section").forEach(e=>e.classList.add("hidden"))
          document.querySelector(".tab-section-item-title.tab-section-item-title-active").classList.remove("tab-section-item-title-active");
          el.classList.add("tab-section-item-title-active");
          document.getElementById(sectionId).querySelector(".tab-section").classList.remove("hidden");
        }
        return;
      })
    })
    
  });


  } catch(e) { console.error(e); }
})();
})();
